import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { editteam } from "../../../API/API";
import { Close } from "../../Common/Images/Images";
import { Switcher } from "../../Switcher/Switcher";
import { CheckPassword } from "../CheckPassword/CheckPassword";

import "./addteamModalStyle.scss";

export const EditteamModal = ({
  close,
  current_data,
  setloader,
  setteam_list,
}) => {
  const [data, setdata] = useState({
    // name: "",
    // // number: "",
    // mail: "",
    password: "",
  });
  const current_store = useSelector((state) => state);

  const [edit_btn, setedit_btn] = useState(false);
  const [check_passsword, setcheck_passsword] = useState(false);
  useEffect(() => {
    setdata({
      ...data,
      name: current_data.name,
      // number: current_data.mobile,
      mail: current_data.email,
      is_admin: current_data.admin,
    });
  }, []);
  useEffect(() => {
    if (
      current_data.name !== data.name ||
      current_data.mobile !== data.number ||
      current_data.email !== data.mail ||
      data.password !== "" ||
      current_data.admin !== data.is_admin
    ) {
      setedit_btn(true);
    } else {
      setedit_btn(false);
    }
  }, [data]);

  return (
    <>
      <div className="addteammodal">
        <div className="modal_main">
          <div className="header">
            <Close clickhandel={close} />
          </div>
          <div className="body">
            <div className="title">
              Name
              {/* {current_data.id} */}
            </div>
            <div className="cust_inp">
              <input
                type="text"
                placeholder="Insert Name"
                value={data.name}
                onChange={(e) => setdata({ ...data, name: e.target.value })}
              />
            </div>
            {/* <div className="title">Number</div>
          <div className="cust_inp">
          <input
          type="text"
          placeholder="Insert Number"
              value={data.number}
              onChange={(e) => setdata({ ...data, number: e.target.value })}
            />
          </div> */}
            <div className="title">Mail</div>
            <div className="cust_inp">
              <input
                type="text"
                placeholder="Insert Mail"
                value={data.mail}
                onChange={(e) => setdata({ ...data, mail: e.target.value })}
              />
            </div>
            {/* <div className="title">Password</div>
          <div className="cust_inp">
            <input
            type="text"
            placeholder={
              current_data.password
              ? new Array(Number(current_data.password)).fill("*").join("")
                  : "Insert Password"
                }
                value={data.password}
                onChange={(e) => setdata({ ...data, password: e.target.value })}
            />
          </div> */}
            <div className="title admin_switch">
              <div>Admin</div>
              <Switcher
                active={
                  data.is_admin === 0
                    ? true
                    : data.is_admin === 1
                    ? false
                    : true
                }
                setactive={() => {
                  setdata((prev) => ({
                    ...prev,
                    is_admin: prev.is_admin === 0 ? 1 : 0,
                  }));
                }}
              />
            </div>
          </div>
          <div className="footer">
            <div
              className="btn"
              type={edit_btn ? "type2" : "type1"}
              onClick={() => {
                if (edit_btn) {
                  setcheck_passsword(true);
                }
              }}
            >
              Save Employee
            </div>
          </div>
        </div>
      </div>
      {check_passsword && (
        <CheckPassword
          close={close}
          btn_name="Save Employee"
          setloader={setloader}
          btn_cb={() => {
            setloader(true);
            editteam(
              {
                name: data.name,
                email: data.mail,
                admin: data.is_admin,
                id: current_data.id,
              },
              current_store.user.token,
              (data) => {
                if (!data.status) {
                  setloader(false);
                  return;
                }
                setloader(false);
                setteam_list([
                  ...data.data.employees.map((el, i) => {
                    return {
                      id: el.id,
                      name: el.name,
                      // mobile: el?.mobile ? el.mobile : "-",
                      email: el.email,
                      password: Math.floor(Math.random() * 2) + 6,
                      admin: el.admin,
                    };
                  }),
                ]);
                close();
              }
            );
          }}
        />
      )}
    </>
  );
};
